import { getBaseUrl } from "./base_url"

enum RequestMethod {
    get = "GET",
}

async function fetchJSON(url: string, method: RequestMethod): Promise<any> {
    const response = await fetch(url, {
        method,
        headers: {
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        return null
    }
    return response.json()
}

export interface TagsView {
    ls: number
    hc?: string
    ka?: string
}

export async function fetchExactagCustomerData(): Promise<TagsView | null> {
    const baseUrl = getBaseUrl(document)
    return await fetchJSON(`${baseUrl}/tags`, RequestMethod.get)
}
